module.exports = __webpack_public_path__ + "static/media/Army-Green_1.342f6dcf.jpg";